export const BC_STATUS = {
  BROUILLON: { label: 'Brouillon', color: 'default' },
  ENVOYE: { label: 'Envoyé', color: 'info' },
  PARTIEL: { label: 'Livré en partie', color: 'warning' },
  RECU: { label: 'Reçu', color: 'success' },
  CLOTURE: { label: 'Clôturé', color: 'success' },
  ANNULE: { label: 'Annulé', color: 'error' },
};

export const DA_STATUS = {
  SOUMISE: { label: 'À traiter', color: 'warning' },
  APPROUVEE: { label: 'Approuvée', color: 'info' },
  COMMANDEE: { label: 'En commande', color: 'success' },
  REFUSEE: { label: 'Refusée', color: 'error' },
  ANNULEE: { label: 'Annulée', color: 'default' },
};
